<div class="auth-layout">
  <div class="auth-layout__container">
    <div class="auth-layout__content">

      <!-- Form Body -->
      <div class="auth-layout__body">
        <router-outlet></router-outlet>
      </div>

      <!-- Side Image -->
      <div class="auth-layout__image">
        <img [imageDirective]="{
          src : 'assets/img/bdsp.svg',
          size: 'large'}" alt="bdsp unit">
      </div>

    </div>
  </div>
</div>